import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "CHANGE_PASSWORD_VIEW", {
  TITLE: "Change password",
  TOKEN_ERROR: "There is an error with your token.",
  SUCCEED: "Password changed",
  SUBMIT_ERROR: "An error occurred when changing password.",
});
